import { render, staticRenderFns } from "./TesseractIconActive.vue?vue&type=template&id=1542a203&"
import script from "./TesseractIconActive.vue?vue&type=script&lang=js&"
export * from "./TesseractIconActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports